import { Phone, Mail, MapPin, Facebook, Twitter, Linkedin } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-hero-gradient text-white mt-12">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">3A Coldrooms & Airconditioning</h3>
            <p className="text-sm text-blue-100 mb-4">
              Professional refrigeration and air conditioning solutions for your business needs.
            </p>
            <div className="flex gap-4">
              <a
                href="#"
                className="hover:text-blue-400 transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="hover:text-blue-400 transition-colors"
                aria-label="Twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="hover:text-blue-400 transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-blue-100">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-blue-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-blue-400 transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-blue-400 transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/clients" className="hover:text-blue-400 transition-colors">
                  Our Clients
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="hover:text-blue-400 transition-colors">
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-blue-400 transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-blue-100">Contact Info</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <Phone className="w-5 h-5 flex-shrink-0 mt-0.5 text-blue-300" />
                <a
                  href="tel:+27314648585"
                  className="hover:text-blue-400 transition-colors"
                >
                  031 464 8585
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="w-5 h-5 flex-shrink-0 mt-0.5 text-blue-300" />
                <a
                  href="mailto:info@3acoldrooms.co.za"
                  className="hover:text-blue-400 transition-colors"
                >
                  info@3acoldroomsandairconditioning.co.za
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5 text-blue-300" />
                <span className="text-blue-100">
                  3A Coldroom<br />
                  55 Kemp Pl, Escombe,<br />
                  Queensburgh, KwaZulu-Natal 4093
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="border-t border-blue-700 mt-8 pt-8 text-center text-sm text-blue-200">
  <p>
    &copy; {new Date().getFullYear()} All Rights Reserved. Design by
    <a
      href="https://www.allinit.co.za/"
      className="text-blue-400 hover:text-blue-300 ml-1"
      target="_blank"
      rel="noopener noreferrer"
    >
      <b>allinit</b>
    </a>
  </p>
</div>

      </div>
    </footer>
  );
};

export default Footer;
